import React from 'react'
import { object } from 'prop-types'
import { PrismicRichText } from '@prismicio/react'

import * as Styled from './styles/ImageBlockWithText.styles'
import CtaLink from './CtaLink'
import LinkWrapper from './LinkWrapper'

const ImageBlockWithText = ({ data, bottomPaddingAdjustment }) => {
  const isImageRightLayout = data.layout_option === 'Image Right / Text Left'

  return (
    <Styled.ImageBlockWithText
      bottomPaddingAdjustment={bottomPaddingAdjustment}
    >
      <Styled.ImageBlockIrregularGrid isImageRightLayout={isImageRightLayout}>
        <Styled.TextContainer isImageRightLayout={isImageRightLayout}>
          <Styled.Title isImageRightLayout={isImageRightLayout}>
            {data.header_text?.text ?? ''}
          </Styled.Title>
          <Styled.BodyText isImageRightLayout={isImageRightLayout}>
            {data.text_content && (
              <PrismicRichText field={data.text_content.richText} />
            )}
          </Styled.BodyText>
          {data.cta_link && data.cta_text?.text ? (
            <CtaLink
              text={data.cta_text?.text ?? ''}
              link={data.cta_link}
              additionalStyles={
                isImageRightLayout
                  ? Styled.AdditionalCtaStylesRightLayout
                  : Styled.AdditionalCtaStylesLeftLayout
              }
            />
          ) : (
            <Styled.NoCtaSpacer>&nbsp;</Styled.NoCtaSpacer>
          )}
        </Styled.TextContainer>
        <Styled.CircleAccent isImageRightLayout={isImageRightLayout}>
          <svg
            viewBox="0 0 106 106"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="53" cy="53" r="50" stroke="#829FE8" strokeWidth="6" />
          </svg>
        </Styled.CircleAccent>
        <Styled.ImageContainer isImageRightLayout={isImageRightLayout}>
          {data.image?.url && (
            <LinkWrapper link={data.cta_link}>
              <Styled.Image>
                <source
                  media="(max-width: 499px)"
                  srcSet={data.image.thumbnails.mobile.url}
                />
                <source media="(min-width: 500px)" srcSet={data.image.url} />
                <img src={data.image?.url} alt={data.image?.alt} />
              </Styled.Image>
            </LinkWrapper>
          )}
        </Styled.ImageContainer>
      </Styled.ImageBlockIrregularGrid>
    </Styled.ImageBlockWithText>
  )
}

ImageBlockWithText.propTypes = {
  data: object,
}

export default ImageBlockWithText
